import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

import AdminTestimonialTableRow from './AdminTestimonialTableRow';
import ImageUploader from '../shared/ImageUploader';
import { getUserDataStringFromMetadata } from '../../utils';
import i18n from '../../config/i18n';

const columns = [
  'avatar',
  'name',
  'specialty',
  'facility',
  'email',
  'webURL',
  'description',
  'actions',
  'onLandingPage',
].map(key => ({
  title: i18n.t(key),
  dataIndex: key,
  key,
  align: 'center',
}));

const AdminTestimonialTable = ({
  testimonials,
  actions,
  callbacks,
  medicalGroups,
  specialties,
}) => {
  const uploadRef = useRef();
  const testimonialRef = useRef();

  const handleClickAvatar = (testimonial) => {
    testimonialRef.current = testimonial;
    uploadRef.current.triggerClick();
  };

  const handleUpload = async (formData) => {
    await actions.uploadTestimonialAvatar(testimonialRef.current, formData);
  };

  // NOTE: We need to get the medicalGroup object and Specialty object here to feed
  // into tableRows by medicalGroupId and specialtyId in the User model.
  const generateData = () => (
    testimonials.map((testimonial) => {
      const {
        medicalGroup,
        specialty,
      } = getUserDataStringFromMetadata(testimonial.user, medicalGroups, specialties);

      // AdminTestimonialTableRow was a component before.
      // Now it is used as a custom hook to generate data for Ant Design Table.
      return AdminTestimonialTableRow({
        key: testimonial.id,
        testimonial,
        specialty,
        medicalGroup,
        callbacks,
        actions,
        onClickAvatar: handleClickAvatar,
      });
    })
  );

  return (
    <div>
      <Table
        title={() => <h1>{i18n.t('manageTestimonials')}</h1>}
        columns={columns}
        dataSource={generateData()}
        scroll={{ x: true }}
      />
      <ImageUploader
        actions={actions}
        doCrop
        hint={i18n.t('avatarHint')}
        title={`${i18n.t('upload')} ${i18n.t('avatar')}`}
        onUpload={handleUpload}
        ref={uploadRef}
      />
    </div>
  );
};

AdminTestimonialTable.propTypes = {
  testimonials: PropTypes.arrayOf(PropTypes.object),
  medicalGroups: PropTypes.arrayOf(PropTypes.object),
  specialties: PropTypes.arrayOf(PropTypes.object),
  callbacks: PropTypes.shape({
    updateTestimonialCallback: PropTypes.func.isRequired,
    deleteTestimonialCallback: PropTypes.func.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    createSuccessAlert: PropTypes.func.isRequired,
    createDangerAlert: PropTypes.func.isRequired,
    updateTestimonialSuccess: PropTypes.func.isRequired,
  }).isRequired,
};

AdminTestimonialTable.defaultProps = {
  testimonials: [],
  medicalGroups: [],
  specialties: [],
};

export default AdminTestimonialTable;



// WEBPACK FOOTER //
// ./src/components/testimonial/AdminTestimonialTable.js